import axiosInstance from '../api/axios';
export const getAllThesisAssigned = async (id) => {
    try {
        const response = await axiosInstance.get(`/thesisAssigned?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};
export const getRecentThesisSubmitted = async (id) => {
    try {
        const response = await axiosInstance.get(`/getRecentThesisSubmitted`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getThesisStatusById = async (id) => {
    try {
        const response = await axiosInstance.get(`/getThesisStatusById?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getInstructorId = async (userName) => {
    try {
        const response = await axiosInstance.get(`/getInstructorId?userName=${userName}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getStudentId = async (userName) => {
    try {
        const response = await axiosInstance.get(`/getStudentId?userName=${userName}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getCodeVivaEligibleSubmissions = async () => {
    try {
        const response = await axiosInstance.get(`/codeVivaEligibleSubmissions`);
        return response.data;
    } catch (error) {
        console.error('Error fetching code viva eligible submissions:', error);
        throw error;
    }
};

export const toggleClearedForCodeViva = async (id) => {
    try {
        const response = await axiosInstance.put(`/toggleClearedForCodeViva?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error toggling cleared for code viva:', error);
        throw error;
    }
};

export const updateCodeExaminer = async (id, codeExaminerId) => {
    try {
        const response = await axiosInstance.put(`/updateCodeExaminer?id=${id}&codeExaminerId=${codeExaminerId}`);
        return response.data;
    } catch (error) {
        console.error('Error updating code examiner:', error);
        throw error;
    }
};